/**
 * Created by cedricgodefroy on 22/11/2017.
 */
angular.module('FlexyBeautyApp.services').
factory('LoyaltyPeriodDataSource', ['PeriodDatasSource','LoyaltyCustomers','$log', function(PeriodDatasSource,LoyaltyCustomers,$log){
    var LoyaltyPeriodDataSource = function(type, period, getDataPrototypeFunction1, getDataPrototypeFunction2, temporalAgregateFunctionType, totalAgregateFunctionType, getPrimaryDatasPrototypeFunction, categorieTable, currentPath,taxMode, typeOfData, additionalFilters) {
        this.nbPassageCustomers = 0;
        PeriodDatasSource.call(this, type, period, getDataPrototypeFunction1, getDataPrototypeFunction2, temporalAgregateFunctionType, totalAgregateFunctionType, getPrimaryDatasPrototypeFunction, categorieTable, currentPath, taxMode, typeOfData, additionalFilters);
    };
    LoyaltyPeriodDataSource.prototype = Object.create(PeriodDatasSource.prototype);

    LoyaltyPeriodDataSource.prototype.initDatas = function() {
        var periodCategoryCustomers = new Array(),
            periodCategoryPassageCustomers = new Array(),
            monthlyCategoryCustomers = new Array(),
            monthlyCategoryPassageCustomers = new Array(),
            monthlyCategoryLoyaltyCustomers = new Array(),
            currentMonthMoment = null,
            nbPeriodCurrentCategoryPassageCustomers = 0,
            periodCurrentCategoryLoyaltyCustomers = new Array(),
            periodCurrentCategoryCustomers = new Array();

        if(!this.primaryDatas )this.primaryDatas = new Array();


        for (var i = 0; i < this.categorieTable.length; i++) {
            this.statByCategory[this.categorieTable[i].id] = 0;

            periodCategoryCustomers[this.categorieTable[i].id] = new Array();
            periodCategoryPassageCustomers[this.categorieTable[i].id] = 0;

            monthlyCategoryCustomers[this.categorieTable[i].id] = new Array();
            monthlyCategoryPassageCustomers[this.categorieTable[i].id] = 0;
            monthlyCategoryLoyaltyCustomers[this.categorieTable[i].id] = new Array();
        }

        $log.debug(this.type);

        for (var i = 0; i < this.arrayOfDay.length; i++) {
            var day = this.arrayOfDay[i];

            if (day) {
                var momentMonthOfDay = day.getMomentDate().startOf('month');

                if(day.isAStatisticDay()) {
                    this.dailyDatas2[day.id] = new Array();

                    for (var j = 0; j < this.categorieTable.length; j++) {

                        // for the day and the category, we need to calcule :
                        //  - dailyCategoryCustomers : the customers of the day for the category
                        //  - nbDailyCategoryPassageCustomers : the number of passage customers of the day for the category
                        //  - dailyCategoryLoyaltyCustomers : the loyalty customers of the day for the category (customers of the day who are ever come with this category during the period before the current day)
                        //  - dailyCategoryNotLoyaltyCustomers : the non-loyalty customers of the day for the category (customers who are come for the first time with this category)
                        var dailyCategoryCustomers = day.getCustomersOfSaleObject([this.categorieTable[j]], this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode),
                            nbDailyCategoryPassageCustomers = day.getNbPassageCustomersOfSaleObject([this.categorieTable[j]], this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode),
                            dailyCategoryLoyaltyCustomers = day.getLoyaltyCustomersOfSaleObject([this.categorieTable[j]], this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode),
                            dailyCategoryNotLoyaltyCustomers = new Array();

                        periodCategoryPassageCustomers[this.categorieTable[j].id] += nbDailyCategoryPassageCustomers;
                        monthlyCategoryPassageCustomers[this.categorieTable[j].id] += nbDailyCategoryPassageCustomers;

                        //with the dailyCategoryCustomers we popule :
                        //  - periodCategoryCustomers : the customers of the period for the category
                        //  - dailyCategoryNotLoyaltyCustomers : the not loyalty customers of the day
                        //  - monthlyCategoryCustomers : the customers of the month for the category
                        for (var k = 0; k < dailyCategoryCustomers.length; k++) {
                            if(dailyCategoryCustomers[k] && this.categorieTable[j] && !periodCategoryCustomers[this.categorieTable[j].id][dailyCategoryCustomers[k].id]){
                                periodCategoryCustomers[this.categorieTable[j].id][dailyCategoryCustomers[k].id] = {
                                    customer : dailyCategoryCustomers[k],
                                    nbVisits : 0
                                };
                            }
                            if(dailyCategoryCustomers[k] && dailyCategoryLoyaltyCustomers.indexOf(dailyCategoryCustomers[k]) == -1) {
                                dailyCategoryNotLoyaltyCustomers.push(dailyCategoryCustomers[k]);
                            }
                            if(this.categorieTable[j] && dailyCategoryCustomers[k] && monthlyCategoryCustomers[this.categorieTable[j].id].indexOf(dailyCategoryCustomers[k]) == -1) {
                                monthlyCategoryCustomers[this.categorieTable[j].id].push(dailyCategoryCustomers[k]);
                            }
                            if(dailyCategoryCustomers[k])
                                periodCategoryCustomers[this.categorieTable[j].id][dailyCategoryCustomers[k].id].nbVisits++;
                        }

                        //with the dailyCategoryLoyaltyCustomers we popule :
                        //  - monthlyCategoryLoyaltyCustomers :
                        for(var k = 0; k < dailyCategoryLoyaltyCustomers.length; k++){
                            if(monthlyCategoryLoyaltyCustomers[this.categorieTable[j].id].indexOf(dailyCategoryLoyaltyCustomers[i]) == -1){
                                monthlyCategoryLoyaltyCustomers[this.categorieTable[j].id].push(dailyCategoryLoyaltyCustomers[i]);
                            }
                        }

                        //popule the datas of the day for the "analyse" tab
                        this.dailyDatas2[day.id][this.categorieTable[j].id] =  (dailyCategoryCustomers.length + nbDailyCategoryPassageCustomers) != 0 ? (dailyCategoryLoyaltyCustomers.length / (dailyCategoryCustomers.length + nbDailyCategoryPassageCustomers)) : 0;

                        $log.debug(day.id + " " + this.categorieTable[j].label + "; clients : [" + this.tabCustomersToString(dailyCategoryCustomers) + "]" +
                            "; nb clients de passage : " + nbDailyCategoryPassageCustomers +
                            "; clients déjà venus : [" +  this.tabCustomersToString(dailyCategoryLoyaltyCustomers) + "]" +
                            "; clients venus une seule fois : [" + this.tabCustomersToString(dailyCategoryNotLoyaltyCustomers) + "]");
                    }

                    //for the day and all categories, we need to calcule :
                    //  - dailyCurrentCategoryCustomers : the customers of the day (all categories)
                    //  - dailyCurrentCategoryLoyaltyCustomers : the loyalty customers of the day (all categories) (customers of the day who are ever come during the period before the current day)
                    var dailyCurrentCategoryLoyaltyCustomers = day.getLoyaltyCustomersOfSaleObject([this.currentPath[this.currentPath.length - 1]], this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay[0].length -1], this.taxMode),
                        dailyCurrentCategoryCustomers = day.getCustomersOfSaleObject([this.currentPath[this.currentPath.length - 1]], this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay[0].length -1], this.taxMode);

                    //for the period and all categories, we need to calcule/populate :
                    //  - periodCurrentCategoryCustomers : the customers of the period
                    //  - periodCurrentCategoryLoyaltyCustomers : the loyalty customers of the period
                    //  - nbPeriodCurrentCategoryPassageCustomers : the number of passage customers

                    //calcul the number of passage customers of the period
                    nbPeriodCurrentCategoryPassageCustomers += day.getNbPassageCustomersOfSaleObject([this.currentPath[this.currentPath.length - 1]], this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay[0].length -1], this.taxMode);

                    //with the dailyCurrentCategoryCustomers we popule :
                    //  - the periodCurrentCategoryCustomers (table of all customers of the period)
                    for(var l = 0; l < dailyCurrentCategoryCustomers.length; l++){
                        if(periodCurrentCategoryCustomers.indexOf(dailyCurrentCategoryCustomers[l]) == -1){
                            periodCurrentCategoryCustomers.push(dailyCurrentCategoryCustomers[l]);
                        }
                    }

                    //with the dailyCurrentCategoryLoyaltyCustomers we popule :
                    //  - the periodCurrentCategoryLoyaltyCustomers (table of all loyalty customers of the period)
                    for(var l = 0; l < dailyCurrentCategoryLoyaltyCustomers.length; l++){
                        if(periodCurrentCategoryLoyaltyCustomers.indexOf(dailyCurrentCategoryLoyaltyCustomers[l]) == -1){
                            periodCurrentCategoryLoyaltyCustomers.push(dailyCurrentCategoryLoyaltyCustomers[l]);
                        }
                    }

                    //calcule primary datas for the case of loyalty customers
                    //we use the dailyCurrentCategoryLoyaltyCustomers in place of periodCurrentCategoryLoyaltyCustomers because we need to calculate the number of visits of each customer
                    //if (this.currentPath.indexOf(LoyaltyCustomers.subCategories.LOYALTY) != -1) {
                    for (var l = 0; l < dailyCurrentCategoryLoyaltyCustomers.length; l++) {
                        var indexLoyaltyCustomers = this.primaryDatas.indexOf(dailyCurrentCategoryLoyaltyCustomers[l]);

                        if (indexLoyaltyCustomers == -1) {
                            dailyCurrentCategoryLoyaltyCustomers[l].nbVisits = 2;
                            this.primaryDatas.push(dailyCurrentCategoryLoyaltyCustomers[l]);
                        }
                        else {
                            this.primaryDatas[indexLoyaltyCustomers].nbVisits++;
                        }
                    }
                    //}

                    //change of month or init
                    if( !currentMonthMoment ||
                        (currentMonthMoment && !currentMonthMoment.isSame(momentMonthOfDay)) ||
                        (currentMonthMoment && i === this.arrayOfDay.length -1) ){

                        //change of month : put tthe datas of the month in monthlyDatas and reinit variables
                        if(currentMonthMoment != null) {
                            var dayId = currentMonthMoment.format('YYYYMMDD');
                            this.monthlyDatas2[dayId] = new Array();

                            var monthArray = new Array();
                            monthArray.push(currentMonthMoment.toDate());

                            for (var j = 0; j < this.categorieTable.length; j++) {

                                //popule the datas of the day for the "analyse" tab
                                this.monthlyDatas2[dayId][this.categorieTable[j].id] = (monthlyCategoryCustomers[this.categorieTable[j].id].length + monthlyCategoryPassageCustomers[this.categorieTable[j].id]) != 0 ?
                                    (monthlyCategoryLoyaltyCustomers[this.categorieTable[j].id].length / (monthlyCategoryCustomers[this.categorieTable[j].id].length + monthlyCategoryPassageCustomers[this.categorieTable[j].id])) : 0;
                            }

                            //initialisation of datas for the new month
                            monthlyCategoryCustomers = new Array();
                            monthlyCategoryLoyaltyCustomers = new Array();
                            for (var j = 0; j < this.categorieTable.length; j++) {
                                monthlyCategoryCustomers[this.categorieTable[j].id] = new Array();
                                monthlyCategoryLoyaltyCustomers[this.categorieTable[j].id] = new Array();
                                monthlyCategoryPassageCustomers[this.categorieTable[j].id] = 0;
                            }
                        }
                        currentMonthMoment = momentMonthOfDay;
                    }

                    this.nbDays += 1;
                }
            }
        }

        var sumOfcategories = 0;
        for (var j = 0; j < this.categorieTable.length; j++) {
            var periodCategoryLoyaltyCustomers = new Array(),
                periodCategoryNonLoyaltyCustomers = new Array(),
                statCategory = 0;

            for(var k in periodCategoryCustomers[this.categorieTable[j].id]){
                if(periodCategoryCustomers[this.categorieTable[j].id][k].nbVisits > 1){
                    periodCategoryLoyaltyCustomers.push(periodCategoryCustomers[this.categorieTable[j].id][k].customer);
                }
                else{
                    periodCategoryNonLoyaltyCustomers.push(periodCategoryCustomers[this.categorieTable[j].id][k].customer);
                }
            }

            $log.debug("Total " + this.categorieTable[j].label +
                "; nb clients de passage : " + periodCategoryPassageCustomers[this.categorieTable[j].id] +
                "; clients venus plusieurs fois : [" +  this.tabCustomersToString(periodCategoryLoyaltyCustomers) + "]" +
                "; clients venus une seule fois : [" + this.tabCustomersToString(periodCategoryNonLoyaltyCustomers) + "]");

            statCategory = (periodCategoryLoyaltyCustomers.length + periodCategoryNonLoyaltyCustomers.length + periodCategoryPassageCustomers[this.categorieTable[j].id]) != 0 ? periodCategoryLoyaltyCustomers.length / (periodCategoryLoyaltyCustomers.length + periodCategoryNonLoyaltyCustomers.length + periodCategoryPassageCustomers[this.categorieTable[j].id]) : 0;;
            this.statByCategory[this.categorieTable[j].id] = statCategory;
            sumOfcategories += statCategory;
        }

        //calcule primary datas for the case of notloyalty customers
        var periodCurrentCategoryNotLoyaltyCustomers = new Array();
        for(var j =0; j < periodCurrentCategoryCustomers.length; j++){
            if(periodCurrentCategoryLoyaltyCustomers.indexOf(periodCurrentCategoryCustomers[j]) == -1){
                periodCurrentCategoryNotLoyaltyCustomers.push(periodCurrentCategoryCustomers[j])
            }
        }

        this.totalStat = this.categorieTable.length != 0? sumOfcategories / this.categorieTable.length:0;
        this.nbPassageCustomers = nbPeriodCurrentCategoryPassageCustomers;

        this.getCustomers();
        this.sortDatas();
    }

    LoyaltyPeriodDataSource.prototype.tabCustomersToString = function(tabCustomer){
        var tabString = "";
        for(var i = 0; i < tabCustomer.length; i ++){
            if(tabString != "")tabString = tabString + ", ";

            if(tabCustomer[i])
                tabString = tabString + tabCustomer[i].firstName + " " + tabCustomer[i].lastName;
        }
       return tabString;
    }

    return LoyaltyPeriodDataSource;
}]);



// WEBPACK FOOTER //
// ./js/services/views/statistics/report/LoyaltyPeriodDataSource.js